<!-- eslint-disable vue/no-v-html -->
<template>
  <ElCollapse v-model="collapseActiveKey">
    <ElCollapseItem
      :title="$t('APPS.DRAFT.STEPS.BASIC_INFO.RSA_KEY_TITLE')"
      name="rsa-key"
    >
      <p
        v-dompurify-html="$t('APPS.DRAFT.STEPS.BASIC_INFO.RSA_DESC')"
        class="text-disabled"
      />

      <CodeBlock v-if="rsaKey" :content="rsaKey" />

      <ElButton
        v-else
        type="primary"
        size="small"
        icon="el-icon-plus"
        :loading="rsaKeyLoading"
        @click="getRSAKey"
      >
        {{ $t('APPS.DRAFT.STEPS.BASIC_INFO.GET_RSA_KEY') }}
      </ElButton>
    </ElCollapseItem>

    <ElCollapseItem
      :title="$t('APPS.DRAFT.STEPS.BASIC_INFO.DYNAMIC_PRICE_KEY_TITLE')"
      name="dynamic-price-key"
    >
      <p
        class="text-disabled"
        v-html="$t('APPS.DRAFT.STEPS.BASIC_INFO.DYNAMIC_PRICE_DESC')"
      />

      <CodeBlock v-if="dynamicPriceKey" :content="dynamicPriceKey" />

      <ElButton
        v-else
        type="primary"
        size="small"
        icon="el-icon-plus"
        :loading="dynamicPriceKeyLoading"
        @click="getDynamicPriceKey"
      >
        {{ $t('APPS.DRAFT.STEPS.BASIC_INFO.GET_DYNAMIC_PRICE_KEY') }}
      </ElButton>

      <ElButton
        v-if="dynamicPriceKey"
        :loading="dynamicPriceKeyLoading"
        type="danger"
        icon="el-icon-refresh"
        @click="getDynamicPriceKey"
      >
        {{ $t('APPS.DRAFT.STEPS.BASIC_INFO.REVOKE_THE_KEY') }}
      </ElButton>
    </ElCollapseItem>
  </ElCollapse>
</template>

<script>
import selection from '@/directives/selection';
import { DraftApps } from '@/api/api';
import CodeBlock from '@@/common/CodeBlock';

export default {
  name: 'InAppPurchaseKeys',
  directives: { selection },
  components: { CodeBlock },

  props: {
    packageName: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      collapseActiveKey: null,
      dynamicPriceKey: null,
      dynamicPriceKeyLoading: false,
      rsaKey: null,
      rsaKeyLoading: false,
    };
  },

  computed: {},

  methods: {
    getRSAKey() {
      this.rsaKeyLoading = true;

      return DraftApps.getRSAKey({ id: this.packageName })
        .then(({ rsa }) => {
          this.rsaKey = rsa;
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.rsaKeyLoading = false;
        });
    },

    getDynamicPriceKey() {
      this.dynamicPriceKeyLoading = true;

      return DraftApps.getDynamicPriceKey({ id: this.packageName })
        .then(({ key }) => {
          this.dynamicPriceKey = key;
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.dynamicPriceKeyLoading = false;
        });
    },
  },
};
</script>
